import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14.732 3.482a.743.743 0 0 1-.75.75h-6.81l-1.91 8.45a.766.766 0 0 1-.51.55.892.892 0 0 1-.22.03.769.769 0 0 1-.52-.2L1.5 10.7a.755.755 0 0 1-.03-1.06.746.746 0 0 1 1.06-.03l1.55 1.46 1.75-7.75a.769.769 0 0 1 .74-.59h7.41a.749.749 0 0 1 .752.752Zm-3.57 2.86-1.03 1.03L9.1 6.342A.75.75 0 1 0 8.042 7.4l1.03 1.03-.79.79a.754.754 0 0 0 0 1.06.742.742 0 0 0 .53.22.725.725 0 0 0 .53-.22l.79-.79.79.79a.748.748 0 0 0 1.06 0 .754.754 0 0 0 0-1.06l-.79-.79 1.03-1.03a.75.75 0 0 0-1.06-1.06Z';
const draw24px =
  'M6.64,19.75a.79.79,0,0,1-.52-.2l-4-3.76a.75.75,0,0,1,0-1.06.75.75,0,0,1,1.06,0L6.2,17.55l3-13.1a.74.74,0,0,1,.73-.58H21.7a.75.75,0,0,1,0,1.5H10.49L7.37,19.16a.76.76,0,0,1-.51.56A.83.83,0,0,1,6.64,19.75ZM18.58,9.48a.75.75,0,0,0-1.06,0l-1.95,1.95-2-1.95a.77.77,0,0,0-1.07,0,.75.75,0,0,0,0,1.06l2,2-1.58,1.57a.75.75,0,0,0,0,1.06.76.76,0,0,0,1.07,0l1.57-1.57,1.57,1.57a.75.75,0,0,0,1.06,0,.75.75,0,0,0,0-1.06L16.63,12.5l1.95-2A.75.75,0,0,0,18.58,9.48Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const FormulaIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'formula'),
) as IconWithRender;

FormulaIcon.displayName = 'FormulaIcon';
FormulaIcon.propTypes = Icon.propTypes;
FormulaIcon.renderIcon = (props) => <FormulaIcon {...props} />;
export default FormulaIcon;
